"use strict";

var note = '1/4" hole punch at dot';

module.exports = function (accumulator, order, product, component) {
  if (component.hole_punch) {
    return accumulator + note;
  }

  return accumulator;
};